import { createContext } from 'react'
import CreationToolError from '../../types/error'

type CreationToolsWelcomeContextProps = {
    error?: CreationToolError
    errorSource?: File | string
    isDraggingFile: boolean
    setError: (error?: CreationToolError) => void
    setErrorSource: (source?: File | string) => void
    setIsDraggingFile: (isDragging: boolean) => void
    onFileAdded?: (files: FileList) => void
}

export const CreationToolsWelcomeContext = createContext({} as CreationToolsWelcomeContextProps)
